import { useCallback, useEffect, useState } from "react";
import { normalizePokemonRef } from "../utils/pokemon";
import usePokemonDetails from "./usePokemonDetails";

function usePokemonSearch({ onSearchError }) {
  const [searchValue, setSearchValue] = useState("");
  const [searchTarget, setSearchTarget] = useState("");
  const [searching, setSearching] = useState(false);

  const { pokemon, loading, error } = usePokemonDetails(searchTarget, {
    enabled: searching,
  });

  useEffect(() => {
    if (!error) {
      return;
    }

    setSearching(false);
    setSearchTarget("");

    if (onSearchError) {
      onSearchError(error);
    }
  }, [error, onSearchError]);

  const handleOnChangeSearch = useCallback((event) => {
    setSearchValue(event.target.value);
  }, []);

  const searchPokemon = useCallback(() => {
    const normalizedValue = normalizePokemonRef(searchValue);

    if (!normalizedValue) {
      return;
    }

    setSearchTarget(normalizedValue);
    setSearching(true);
    setSearchValue("");
  }, [searchValue]);

  return {
    searchValue,
    pokemon,
    searching,
    loading,
    handleOnChangeSearch,
    searchPokemon,
  };
}

export default usePokemonSearch;
